import store from '@/store'
import Actions from '@/store/Actions'
import Rotas from '@/router/Rotas';
import { computed } from 'vue';
import FuncoesHelper from '@/helpers/FuncoesHelper';

export default class Middleware {
    static obterParametrosRotaChecklist() {
        const path = location.pathname;
        const partesDoPath = location.pathname.split('/');

        const identificador = partesDoPath[1];
        const localRealizacao = partesDoPath[2] || 'origem';
        let etapa = path.match(/\/etapa\/(\d+)/);
        etapa = etapa ? parseInt(etapa[1]) : 1;

        let parametro = null;
        if (partesDoPath.includes(Rotas.RESUMO.chave)) {
            etapa = Rotas.RESUMO.chave;
        } 
        else if (partesDoPath.includes(Rotas.ASSINATURA.chave)) {
            etapa = Rotas.ASSINATURA.chave;
            if (partesDoPath.length > 3) {
                parametro = partesDoPath[3];
            }
        } else if (partesDoPath.includes(Rotas.MODULOS.chave)) {
            etapa = Rotas.MODULOS.chave;
        }
        
        store.dispatch(Actions.OBTER_CHECKLIST, { identificador, localRealizacao, etapa, parametro })
    }

    static validaChecklistFinalizado() {
        const path = location.pathname;
        const partesDoPath = path.split('/');
        const identificador = partesDoPath[1];

        const checklistFinalizado = computed(() => store.state.recebimentoFinalizado).value
        const moduloAtual = computed(() => store.state.modulos.find(module => module.recebimentoFinalizado == 'N')).value
        if (checklistFinalizado == 'S' || !moduloAtual) {
            FuncoesHelper.pushRouter(Rotas.MODULOS.nome, { identificador })
        }
        
        if (moduloAtual) {
            FuncoesHelper.pushRouter(Rotas.ETAPAS.nome, {
                identificador: identificador,
                localRealizacao: moduloAtual.localRealizacao.toLowerCase(),
                modulo: moduloAtual.idChecklistModulo,
                etapa: 1
            })
        }

    }
}

